import http from './api'

const route = '/videos/'

export default {

  listarVideos: () => (http.get(route + 'listar')),

}
